/** The one number formatter for the OMS dashboard — Indian grouping, no decimals. */
const NUMBER_FORMAT = new Intl.NumberFormat('en-IN', { maximumFractionDigits: 0 });

export function formatNumber(n: number): string {
  return NUMBER_FORMAT.format(n);
}

/** Whole-number percentage with the % sign, e.g. formatPct(0.914) → "91%". */
export function formatPct(ratio: number): string {
  return `${Math.round(ratio * 100)}%`;
}
